module.exports = __webpack_public_path__ + "media/images/flags/64/Afghanistan-f54ce990f076814d2d2a2f565192c6a9.png";